import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import '../../css/App.css';
import ReferralPathQuestions from './referralpathquestions';


function QuestionBlock(props) {

let headings =  Object.keys(props.paths)
let questionBlocks=headings.map((heading, index)=>
<ReferralPathQuestions heading ={heading} questions={props.paths[heading]} key={index} />)


    return(
        <>
        <Typography variant='h4'>
        {props.pathType}
        </Typography>
       
        {questionBlocks}
        </>
       
    )

    }

export default QuestionBlock





 





